/**
 * Indicate is large screen
 *
 * @param {Object} breakpoint breakpoint
 * @param {boolean} isExtraLarge is parameter isExtraLarge
 * @returns {boolean} Breakpoint
 */
 export const isLargeScreen = (breakpoint, isExtraLarge) =>
 (isExtraLarge ? breakpoint.xlOnly : breakpoint.lgOnly || breakpoint.xlOnly)